
import InfiniteScrollSection from '@/components/search/InfiniteScrollSection';
import KeywordSection from '@/components/search/KeywordSection';
import checkMobile from '@/utils/checkMobile';
import { FILTER_ORDER_OPTIONS } from '@/utils/filter/filterOptions';
import { mapGetters } from 'vuex';
import AccordionSelectMenu from '../common/AccordionSelectMenu.vue';

export default {
  name: 'SearchListSection',
  components: {
    InfiniteScrollSection,
    KeywordSection,
    AccordionSelectMenu,
  },
  data() {
    return {
      FILTER_ORDER_OPTIONS,
    };
  },
  computed: {
    ...mapGetters('search', ['isEmptySearchResult', 'totalSearchCount']),
    isMobile() {
      return checkMobile(process.client);
    },
    selectedOrderOption() {
      return this.$route.query?.order || this.FILTER_ORDER_OPTIONS[0].value;
    },
  },
  mounted() {
    // 이걸 해 줘야, searchHeader와 하의 컴포넌트에 선언해 둔 sticky가 동작합니다.
    this.removeOverflowStyle();
  },
  beforeDestroy() {
    this.restoreOverflowStyle();
    document.body.classList.remove('stop-scrolling');
  },
  methods: {
    restoreOverflowStyle() {
      document.body.style.overflowX = 'hidden';
    },
    removeOverflowStyle() {
      document.body.style.overflowX = 'unset';
    },
    changeOrderOption(selectedOrderOption) {
      this.$router.push({
        query: {
          ...this.$route.query,
          order: selectedOrderOption,
        },
      });
    },
  },
};
